import { render, staticRenderFns } from "./smooth.vue?vue&type=template&id=2b8b20f3&"
import script from "./smooth.vue?vue&type=script&lang=js&"
export * from "./smooth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports